import React, {Component} from 'react';
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {Backdrop, Block, Overlay, Portal} from "reakit";
import {Box, Flex, Heading, Image, Text} from 'rebass';
import IosArrowBack from 'react-ionicons/lib/IosArrowBack'
import Leaves from './Leaves'
import chevronRight from "../../resources/img/icons/Chevron_2@1x.png";

const FilterOverlay = styled(Overlay)`
width: 100%;
height: 100%;
`;


class MobileWaves extends Component {

	state = {
		gender: '',
		grade: '',
		dorm: '',
		location: '',
		type: ''
	};

	handleSelect = () => {
		console.log('select')
	};

	render() {
		const {profile} = this.props;
		return (
			<Overlay.Container>
				{overlay => (
					<Block>
						<Flex onClick={overlay.show} {...overlay}>
							<Box><Text  fontWeight={600}>{profile && profile.first_name}'s Leaves</Text></Box>
							<Box mr={'auto'}/>
							<Box><Image src={chevronRight}/> </Box>
						</Flex>
						<Backdrop use={[Portal, Overlay.Hide]} {...overlay} />
						<FilterOverlay use={Portal} {...overlay}>
							{overlay.visible &&
							<Box>
								<IosArrowBack fontSize={'30px'} onClick={overlay.hide}/>
								<Heading>{profile.first_name}'s Leaves</Heading>


								<Leaves student={profile}/>

							</Box>}
						</FilterOverlay>
					</Block>
				)}
			</Overlay.Container>
		)
	}
}

MobileWaves.propTypes = {
	profile: PropTypes.object
};

MobileWaves.defaultProps = {
	profile: {first_name: '', last_name: ''}
};


export default MobileWaves
